import React from "react";
import api, {getOrganizationCard} from "../../api/organizations";
import {logSuccess} from "../../store/message";

const initialData = {
  organizationInfo: null,
  files: null,
  deletedOrganization: null,
  isUpdatingOrganization: false,
  isUpdatingProfile: false,
  updatedOrganization: null,
  updatedProfile: null,
  updatedLogo: null,
  isEdited: true,
  deleteModalOpen: false,
};

export default function useOrganizationEdit() {
  const [organizationData, setOrganizationsData_] = React.useState(initialData);

  const setOrganizationsData = newData => {
    const newOrganizationsData = {
      ...organizationData,
      ...newData
    };

    setOrganizationsData_(newOrganizationsData);
  };

  function updateOrganization(id, data) {
    console.log(data);
    setOrganizationsData({isUpdatingOrganization: true});
    api.updateOrganization(id, data).then(({data}) => {
      setOrganizationsData({updatedOrganization: data, isUpdatingOrganization: false});
    });
  }

  function updateOrganizationProfile(id, data) {
    //console.log(id);
    //console.log(data);
    setOrganizationsData({isUpdatingProfile: true});
    if (data) {
      api.updateOrganizationProfile(id, data).then(({data}) => {
        setOrganizationsData({updatedProfile: data, isUpdatingProfile: false});
        logSuccess("Данные успешно сохранены");
      });
    }
    else {
      setOrganizationsData({updatedProfile: null, isUpdatingProfile: false});
    }
  }

  function addOrganizationFiles(id, files) {
    Promise.all(files.map(file => api.addOrganizationFile(id, file))).then(() => {
      getOrganization(id);
    });
  }

  function deleteOrganizationFile(id) {
    const orgId = organizationData.organizationInfo.info.id;
    orgId && api.deleteOrganizationFile(orgId, id).then(() => {
      getOrganization(orgId);
    })
  }

  function setOrganizationLogo(id, file) {
    api.updateLogo(id, file).then(({data}) => {
      setOrganizationsData({updatedLogo: data});
      getOrganizationCard(id);
    });
  }

  function deleteOrganization(id) {
    api.deleteOrganization(id).then(({data}) => {
      setOrganizationsData({deletedOrganization: data});
    });
  }

  function getOrganization(id) {
    Promise.all([
      api.getOrganizationFullInfo(id),
      api.getOrganizationSpecialities(id),
      api.getOrganizationWorldSkills(id),
      api.getOrganizationFiles(id),
      api.getOrganizationServices(id),
      api.getOrganizationProfileInfo(id),
      /*   api.getOrganizationRoles(id),
         api.getOrganizationAccounts(id),*/
      api.getOrganizationBankCreds(id),
    ]).then(([organizationInfo, specialities, worldSkills, files, services, profile, bank]) => {
      setOrganizationsData({
        organizationInfo: {
          about: organizationInfo.data.about,
          main: {
            ...organizationInfo.data.data,
            specialities: specialities.data,
            worldSkills: worldSkills.data
          },
          info: organizationInfo.data.info,
          services: services ? (services.data ? services.data.data : {}) : {},
          bank: bank ? (bank.data ? bank.data.data : {}) : {},
          profile: {
            ...profile.data,
            info: profile.data ? profile.data.info : {},
            roles: profile.data ? profile.data.roles : []
          },
          worldSkills: worldSkills ? worldSkills.data : [],
          specialities: specialities? specialities.data : [],
        },
        files: files.data,
      });
    });
  }

  return {
    organizationData,
    setOrganizationsData,
    getOrganization,
    updateOrganization,
    addOrganizationFiles,
    deleteOrganizationFile,
    setOrganizationLogo,
    deleteOrganization,
    updateOrganizationProfile
    /* deleteOrganization, addOrganizationPhoto */
  };
}
